var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.wxaCodeImage)?_c('div',{staticClass:"content-center"},[_c('el-row',[_c('el-col',[_c('img',{attrs:{"src":_vm.wxaCodeImage}})]),_c('el-col',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.downDistributorCode}},[_vm._v("下载"),_c('i',{staticClass:"el-icon-download el-icon--right"})])],1)],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }